import React from 'react';
import Permanence from './Permanence';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';

const PermanenceWrapper = () => {
    return (
        <ServicesChartsDataProvider
            module={{
                sectionTitle: 'da Média de Dias de Permanência'
            }}
        >
            <Permanence />
        </ServicesChartsDataProvider>
    );
};

export default PermanenceWrapper;
